import script from "./qtDetailLayout.vue?vue&type=script&setup=true&name=qtDetailLayout&lang=js"
export * from "./qtDetailLayout.vue?vue&type=script&setup=true&name=qtDetailLayout&lang=js"

import "./qtDetailLayout.vue?vue&type=style&index=0&id=584d7ca2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584d7ca2"]])

export default __exports__